module.exports = __webpack_public_path__ + "static/rendering3-2ee32ffda08b9e8621c06de581a47af8.png";